/*
 * Gift-card recipient add-to-cart (G1.6).
 *
 * Slide Cart takes over the Add to cart click and only sends the variant id and
 * quantity, which drops the recipient fields (email, name, message, send date).
 * When "send as a gift" is ticked, add the WHOLE product form instead, then
 * refresh/open Slide Cart. Shopify's validation errors go to the theme's own
 * recipient form through the cart-error event it already listens to.
 * Unticked (buying for yourself): nothing changes, Slide Cart adds as before.
 */
(function () {
  'use strict';
  var script = document.currentScript;
  var form = script && document.getElementById(script.dataset.productForm);
  if (!form) return;
  var busy = false;

  function variantId() {
    var input = form.querySelector('.product-variant-id') || form.querySelector('[name="id"]');
    return input ? input.value : '';
  }

  function sendingToRecipient() {
    var box = form.querySelector('recipient-form input[type="checkbox"]');
    return !!(box && box.checked);
  }

  function publishEvent(name, detail) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS[name], detail);
  }

  function onAddToCart(e) {
    var button = e.target.closest && e.target.closest('[type="submit"]');
    var ours = e.type === 'submit' ? e.target === form : !!button && (button.form === form || form.contains(button));
    if (!ours || !sendingToRecipient()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var id = variantId();
    var body = new FormData(form);
    body.set('id', id); // the theme keeps the id input disabled, so FormData skips it

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          publishEvent('cartError', {
            source: 'product-form',
            productVariantId: id,
            errors: res.data.errors || res.data.description,
            message: res.data.message
          });
          return;
        }
        publishEvent('cartUpdate', { source: 'product-form', productVariantId: id, cartData: res.data });
        if (typeof window.SLIDECART_UPDATE === 'function') {
          window.SLIDECART_UPDATE();
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        publishEvent('cartError', { source: 'product-form', productVariantId: id, errors: err.message, message: err.message });
      })
      .then(function () {
        busy = false;
      });
  }

  // Capture phase on window runs before Slide Cart's delegated click handler.
  window.addEventListener('click', onAddToCart, true);
  window.addEventListener('submit', onAddToCart, true);
})();
